import { SkeletonComponent } from '@design-system';
import React from 'react';

export const CategorySkeleton: React.FC = () => {
    return (
        <>
            {[...Array(6)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '155px',
                        width: '175px',
                        margin: '8px',
                        borderRadius: '12px'
                    }}
                />
            ))}
        </>
    );
};
